const COLOR_OPTIONS = [
  { value: 'normal', label: '平色图' },
  { value: 'colored', label: '彩绘图' },
];

const PLAY_TYPE_OPTIONS = [
  { value: 'single_color', label: '单色' },
  { value: 'mixed_color', label: '混色' },
];

const normalizeColor = (value) => (
  COLOR_OPTIONS.some((item) => item.value === value) ? value : COLOR_OPTIONS[0].value
);

const normalizePlayType = (value) => (
  PLAY_TYPE_OPTIONS.some((item) => item.value === value) ? value : PLAY_TYPE_OPTIONS[0].value
);

const formatColor = (value) => (
  COLOR_OPTIONS.find((item) => item.value === normalizeColor(value)).label
);

const formatPlayType = (value) => (
  PLAY_TYPE_OPTIONS.find((item) => item.value === normalizePlayType(value)).label
);

const withOriginalTypes = (payload, form) => {
  const result = { ...payload };
  delete result.color;
  delete result.play_type;
  if (form.task_type === '原创') {
    result.color = normalizeColor(form.color);
    result.play_type = result.color === 'colored' ? 'single_color' : normalizePlayType(form.play_type);
  }
  return result;
};

export {
  COLOR_OPTIONS,
  PLAY_TYPE_OPTIONS,
  normalizeColor,
  normalizePlayType,
  formatColor,
  formatPlayType,
  withOriginalTypes,
};
